"use client";

import { createPhiPublicRuntimeModuleClientBoundary } from "@phis/ui/next/areas/public-client";

import { PHI_SITE_MODULES_CLIENT } from "@/generated/site-modules-client-public";

export const PhiPublicRuntimeModuleClientBoundary =
  createPhiPublicRuntimeModuleClientBoundary(PHI_SITE_MODULES_CLIENT);
